module.exports = __webpack_public_path__ + "static/img/04.664afd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/contestdream/tutorial/04.svg
// module id = yHAN
// module chunks = 13